import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-72d94354"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "head-container"
};
const _hoisted_3 = {
  class: "head-logo"
};
const _hoisted_4 = {
  href: "/teachCenter.html"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "head-infor"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = {
  key: 2,
  class: "head-login"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = {
  key: 3,
  class: "head-user"
};
const _hoisted_11 = {
  class: "avatar-box"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "user-name"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("退出");

import axios from 'axios';
export default {
  props: {
    // 是否显示教研中心
    showTeachBtn: Boolean
  },
  emits: ['getUserInfo', 'userRole'],

  setup(__props, {
    emit
  }) {
    const $http = inject('$http');
    const $utils = inject('$utils');
    const $config = inject('$config');
    const userInfo = ref(null);
    const zhsRole = ref(0);
    const userRole = ref(0);
    const logoUrl = ref('');
    const backUrl = ref('/index.html'); // 获取用户信息

    const getUserInfo = async () => {
      let token = $utils.getCookie('X-Access-Token');

      if (token) {
        const res = await $http.getUserInfo();
        userInfo.value = res;
        console.log('用户信息', res);

        if (userInfo.uuid) {
          getUserZhsRole();
          getUserIdentity();
        }

        emit('getUserInfo', userInfo.value);
        return;
      }

      return null;
    };

    getUserInfo(); // 获取用户智慧树权限

    const getUserZhsRole = async () => {
      const res = await $http.getUserZhsIdentity({
        uuid: userInfo.uuid
      }); //  role = 2 有数据中心权限，role=0 虽然有myuni权限，但是没有数据中心权限 role = 1 数据中心权限、教学指挥中心权限,

      console.log('智慧树权限', res);
      zhsRole = res.role;
    }; // 获取用户智慧树角色


    const getUserIdentity = async () => {
      let params = {
        schoolId: $config.schoolId,
        uuid: userInfo.uuid
      };
      const res = await $http.getUserIdentity(params); // 	0:未认证 1:管理者 2:老师 3:学生

      console.log('智慧树角色', res);
      userRole = res;
      emit('userRole', userRole);
    }; // 基础配置信息


    const getBaseSet = async () => {
      const res = await $http.getBaseSet();
      logoUrl.value = res.home_logo_url || require('../../../assets/images/home_logo.png'); // 浏览器图标

      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = res.icon_url;
      document.getElementsByTagName('head')[0].appendChild(link);
    };

    getBaseSet();

    const logout = async () => {
      try {
        let token = $utils.getCookie('X-Access-Token');

        if (token) {
          let res = await $http.logout();
          $utils.delCookie('X-Access-Token');
          zhsLogout();
        } else {
          // window.location.href = `/login.html`
          window.location.href = `/index.html`;
        }
      } catch (e) {
        console.log(e);
      }
    }; // 智慧树退出登录


    const zhsLogout = async () => {
      // service 智慧树退出登录
      axios.defaults.withCredentials = true;
      axios.post('//oauth.zhihuishu.com/logout').then(res => {
        console.log(res);
      }).catch(error => {
        console.log(error);
      }); // window.location.href = `//passport.zhihuishu.com/logout?service=https://${process.env.VUE_APP_HOST}/login.html`

      window.location.href = `//passport.zhihuishu.com/logout?service=https://${process.env.VUE_APP_HOST}/index.html`;
    };

    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", _hoisted_4, [_createElementVNode("img", {
        src: require('../../../assets/images/teachCenter/teachCenter_logo.png'),
        alt: ""
      }, null, 8, _hoisted_5)])]), _createElementVNode("div", _hoisted_6, [userInfo.value ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "online",
        href: backUrl.value,
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.goBackPlat && _ctx.goBackPlat(...args)),
        target: "_blank"
      }, " 门户首页 ", 8, _hoisted_7)) : _createCommentVNode("", true), userInfo.value && __props.showTeachBtn ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        class: "online",
        href: "/teachCenter.html",
        onClick: _cache[1] || (_cache[1] = (...args) => _ctx.goBackPlat && _ctx.goBackPlat(...args)),
        target: "_blank"
      }, " 教研中心 ")) : _createCommentVNode("", true), !userInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("a", {
        href: _ctx.$zhsLoginUrl,
        target: "_self"
      }, "登录", 8, _hoisted_9)])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        class: "avatar",
        src: userInfo.value.avatar ? userInfo.value.avatar : require('../../../assets/images/user_icon.png')
      }, null, 8, _hoisted_12)]), _createVNode(_component_el_dropdown, {
        trigger: "hover",
        "show-arrow": false
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: logout
          }, {
            default: _withCtx(() => [_hoisted_14]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_13, _toDisplayString(userInfo.value.realname), 1)]),
        _: 1
      })]))])])]);
    };
  }

};